import * as React from 'react';

import { InfrastructureControlContainer, InfrastructureDropdownContainer } from './Infrastructure';
import { InfrastructureContextProvider } from './Infrastructure/InfrastructureContext';
import { ListingButtonContainer } from './ListingButton';
import * as styles from './styles.css';
import { Navigation } from '../../components/Navigation';
import { useIsDailyrentDesktopHybridExpActive } from '../../hooks/useIsDailyrentDesktopHybridExpActive';

export const NavigationContainer: React.FC = () => {
  const isHybridExpActive = useIsDailyrentDesktopHybridExpActive();

  return (
    <Navigation indent="L">
      <InfrastructureContextProvider>
        <div className={styles['navigation-buttons-container']}>
          <InfrastructureControlContainer />
          {!isHybridExpActive && <ListingButtonContainer />}
        </div>
        <InfrastructureDropdownContainer />
      </InfrastructureContextProvider>
    </Navigation>
  );
};

NavigationContainer.displayName = 'NavigationContainer';
